module.exports = __webpack_public_path__ + "static/media/redes03.03c69b77.svg";